import { fromAppointmentBannerToCampaignInfoBanner } from "./adapters.js";
import { useBrPageContext } from "../../context/context/context.js";
import { getBrPageContent } from "../../utils/utils/get-br-page-content.js";
const emptyContent = {
  appointmentDisplayType: "single",
  appointmentTypes: [],
  campaignInfoBanner: null,
  appointmentFaq: null
};
const useBloomreachAppointmentContent = () => {
  const page = useBrPageContext();
  if (!page) {
    return emptyContent;
  }
  const reference = page.getComponent("main")?.getModels()?.appointmentConfigurationDocument;
  if (!reference) {
    return emptyContent;
  }
  if (!reference.$ref) {
    return emptyContent;
  }
  const content = getBrPageContent(page, reference);
  if (!content) {
    console.warn(
      `Cannot find main content for ProductDetail BR page. Got: ${content} for $ref: ${reference.$ref}`
    );
    return emptyContent;
  }
  function mapAppointmentType(appointmentTypeRef) {
    const appointmentType = getBrPageContent(page, appointmentTypeRef);
    return {
      typeId: appointmentType?.typeId,
      icon: appointmentType?.icon,
      typeDetails: getBrPageContent(page, appointmentType?.typeDetails),
      appointmentConfirmationContent: getBrPageContent(
        page,
        appointmentType?.appointmentConfirmationContent
      )
    };
  }
  let appointmentTypesSingleOrGrouped;
  if (content.displayAppointments === "group") {
    appointmentTypesSingleOrGrouped = content.appointmentTypesGroup.map((group) => {
      return {
        title: group?.groupTitle,
        icon: group?.groupIcon,
        appointmentTypes: group?.appointmentTypeCompound.map(mapAppointmentType)
      };
    });
  } else appointmentTypesSingleOrGrouped = content.appointmentTypes.map(mapAppointmentType);
  return {
    appointmentDisplayType: content.displayAppointments,
    appointmentTypes: appointmentTypesSingleOrGrouped,
    campaignInfoBanner: fromAppointmentBannerToCampaignInfoBanner(content.appointmentBanner),
    // Because of the structure of the returned Bloomreach data we need to restructure it,
    // from objects that contain $ref to ones that contain an id, a question and an answer.
    appointmentFaq: {
      title: content.faqListAppointment?.title,
      faqItems: content.faqListAppointment?.faqitem?.map((reference2) => getBrPageContent(page, reference2)).filter(({ type }) => type === "faqitem").map(({ id, question, answer }) => ({ id, question, answer: answer.value }))
    }
  };
};
export {
  useBloomreachAppointmentContent
};
//# sourceMappingURL=use-bloomreach-appointment-content.js.map
